import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../../types/store'
import { alertErrorMessage } from '../../../../utils/Errors'
import { IProductGroup } from '../../../../types/product'
import { getUrlWithVersion } from '../../../../api/api'

export const fetchProductsGroups = createAsyncThunk<
    { productsGroups: IProductGroup[] },
    void,
    ThunkConfig<string>
>('productsSlice/fetchProductsGroups', async (_, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
    } = thunkAPI

    try {
        const { data } = await api.get<IProductGroup[]>(
            getUrlWithVersion(`/groups`)
        )
        return { productsGroups: data }
    } catch (e) {
        alertErrorMessage(e)
        return rejectWithValue('Failed to fetch product groups')
    }
})
